export default __webpack_public_path__ + "static/media/company.1ce3757d.svg";